"use client";

import * as React from "react";
import { Check, ChevronsUpDown, PlusCircle, Building } from "lucide-react";
import { cn } from "../../lib/utils.js";
import { Button } from "../button.js";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "../command.js";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../popover.js";
import { useOrganization } from "../../lib/organization/OrganizationProvider.js";

export function OrganizationSwitcher() {
  const [open, setOpen] = React.useState(false);
  const { organizations, currentOrg, setCurrentOrg, isLoading } = useOrganization();

  if (isLoading && !currentOrg) {
    return <Button variant="outline" size="sm" className="w-[200px] justify-between" disabled>Loading...</Button>;
  }

  if (organizations.length === 0) {
    return null;
  }

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-[200px] justify-between"
        >
          <Building className="mr-2 h-4 w-4" />
          {currentOrg?.name || "Select Organization..."}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-0">
        <Command>
          <CommandInput placeholder="Search organizations..." />
          <CommandList>
            <CommandEmpty>No organization found.</CommandEmpty>
            <CommandGroup heading="Organizations">
              {organizations.map((org) => (
                <CommandItem
                  key={org.id}
                  onSelect={() => {
                    setCurrentOrg(org);
                    setOpen(false);
                  }}
                >
                  <Check
                    className={cn(
                      "mr-2 h-4 w-4",
                      currentOrg?.id === org.id ? "opacity-100" : "opacity-0"
                    )}
                  />
                  {org.name}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
          <CommandSeparator />
          <CommandList>
            <CommandGroup>
              <CommandItem
                onSelect={() => {
                  // This would trigger a "Create Org" modal if implemented
                  console.log("Create Organization clicked");
                  setOpen(false);
                }}
              >
                <PlusCircle className="mr-2 h-4 w-4" />
                Create Organization
              </CommandItem>
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
